module.exports = __webpack_public_path__ + "9ecf9526500688cf116058a08c7a975c.svg";